import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow _mt-6 js-main-content" }
const _hoisted_2 = {
  class: "gfu-heading gfu-heading--main",
  "data-qa": "page-title"
}
const _hoisted_3 = { class: "gfu-subheading gfu-subheading--main" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h3 _mt-5" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cart_table = _resolveComponent("cart-table")
  const _component_order_details_location = _resolveComponent("order-details-location")
  const _component_redeem_gift_cards = _resolveComponent("redeem-gift-cards")
  const _component_order_summary_list = _resolveComponent("order-summary-list")
  const _component_dynamic_currency_conversion_wrapper = _resolveComponent("dynamic-currency-conversion-wrapper")
  const _component_payment_types = _resolveComponent("payment-types")
  const _component_adyen_order_payment_form = _resolveComponent("adyen-order-payment-form")
  const _component_stripe_payment_form = _resolveComponent("stripe-payment-form")
  const _component_checkout_footer = _resolveComponent("checkout-footer")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")
  const _component_project_context_modal = _resolveComponent("project-context-modal")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutHeader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.ResumePaymentPageSubHeader), 1 /* TEXT */),
    _createVNode(_component_box, {
      class: "_mt-3 _mb-6",
      "data-qa": "cart-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_cart_table, { "order-id": $props.orderID }, null, 8 /* PROPS */, ["order-id"]),
        ($options.isStoreDataInitialized)
          ? (_openBlock(), _createBlock(_component_order_details_location, _mergeProps({ key: 0 }, $options.mappedOrderDetailsLocationModel, { onOrderDetailsLocationChanged: $options.onOrderDetailsLocationChanged }), null, 16 /* FULL_PROPS */, ["onOrderDetailsLocationChanged"]))
          : _createCommentVNode("v-if", true),
        ($options.isStoreDataInitialized)
          ? (_openBlock(), _createBlock(_component_redeem_gift_cards, {
              key: 1,
              "project-id": _ctx.projectID,
              "currency-symbol": $options.currencySymbol,
              "is-checkout-processing": $setup.isProcessingView,
              onGiftCardsChanged: $options.onGiftCardsChanged
            }, null, 8 /* PROPS */, ["project-id", "currency-symbol", "is-checkout-processing", "onGiftCardsChanged"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_order_summary_list, { "order-id": $props.orderID }, null, 8 /* PROPS */, ["order-id"]),
        (_ctx.isInitialized)
          ? (_openBlock(), _createBlock(_component_dynamic_currency_conversion_wrapper, {
              key: 2,
              "project-id": _ctx.projectID,
              "order-id": $props.orderID,
              "order-code": $props.orderCode,
              reason: _ctx.paymentMethodsByOrderPaymentType,
              "can-be-paid-in-installments": $options.canBePaidInInstallments,
              "handle-tax-without-shipping": $props.handleTaxWithoutShipping,
              "payment-currency-strategy": $props.paymentCurrencyStrategy
            }, null, 8 /* PROPS */, ["project-id", "order-id", "order-code", "reason", "can-be-paid-in-installments", "handle-tax-without-shipping", "payment-currency-strategy"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_payment_types, {
          "current-payment-type": _ctx.paymentType,
          "checkout-mode": $options.checkoutMode,
          "effective-payable-amount": $options.effectivePayableAmount,
          "order-code": $props.orderCode,
          onPaymentTypeChanged: $options.onPaymentTypeChanged,
          "data-qa": "installments-wrapper"
        }, null, 8 /* PROPS */, ["current-payment-type", "checkout-mode", "effective-payable-amount", "order-code", "onPaymentTypeChanged"]),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentMethodSectionTitle), 1 /* TEXT */),
        ($options.isAdyenPaymentProvider)
          ? (_openBlock(), _createBlock(_component_adyen_order_payment_form, _mergeProps({ key: 3 }, $options.paymentOptionsModel, { "data-qa": "payment-section" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        ($options.isStripePaymentProvider)
          ? (_openBlock(), _createBlock(_component_stripe_payment_form, _mergeProps({ key: 4 }, $options.paymentOptionsModel, { "data-qa": "stripe-payment-form" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_checkout_footer),
        _createVNode(_component_progress_overlay, { visible: $setup.isProcessingView }, null, 8 /* PROPS */, ["visible"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_project_context_modal)
  ]))
}